import {
  UpdateDoctorDetailsActionTypes,
  UPDATE_DOCTOR_DETAILS_FAIL,
  UPDATE_DOCTOR_DETAILS_LOADING,
  UPDATE_DOCTOR_DETAILS_SUCCESS,
  UpdateDoctorDetailsState,
  UPDATE_DOCTOR_DETAILS_UPDATE_API_MSG,
  UPDATE_DOCTOR_DETAILS_UPDATE_API_RES,
} from "./ActionTypes";
import { UpdateDoctorDetailsRes } from "./Model";

const initialStateUpdatePosts: UpdateDoctorDetailsState = {
  loading: false,
  updateNoteResRes: {} as UpdateDoctorDetailsRes,
  errorMsg: "",
  status: 0,
};
export const updateDoctorDetailsReducer = (
  state = initialStateUpdatePosts,
  action: UpdateDoctorDetailsActionTypes
): UpdateDoctorDetailsState => {
  switch (action.type) {
    case UPDATE_DOCTOR_DETAILS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case UPDATE_DOCTOR_DETAILS_SUCCESS:
      return {
        ...state,
        updateNoteResRes: action.payload,
      };
    case UPDATE_DOCTOR_DETAILS_FAIL:
      return {
        ...state,
        updateNoteResRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case UPDATE_DOCTOR_DETAILS_UPDATE_API_MSG:
      return {
        ...state,
        updateNoteResRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case UPDATE_DOCTOR_DETAILS_UPDATE_API_RES:
      return {
        ...state,
        updateNoteResRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
